const lang = {
    // 侧边栏目录
    routeList: [
        {
            path: "/admin",
            title: "/root/auth",
            name: "权限管理",
            icon: "el-icon-user",
            catalogue: true,
            children: [
                {
                    path: "admin",
                    name: "管理员列表",
                    isShow: true,
                },
                {
                    path: "admin-detail",
                    name: "管理员详情",
                    isShow: false,
                },
                {
                    path: "admin-auth-role",
                    name: "角色列表",
                    isShow: true,
                },
                {
                    path: "admin-auth-role-detail",
                    name: "角色详情",
                    isShow: false,
                },
                {
                    path: "admin-auth-api",
                    name: "权限列表",
                    isShow: true,
                },
                {
                    path: "admin-auth-api-detail",
                    name: "权限详情",
                    isShow: false,
                },
                {
                    path: "admin-auth-category",
                    name: "权限分类",
                    isShow: true,
                },
                {
                    path: "admin-auth-category-detail",
                    name: "权限分类",
                    isShow: false,
                },
            ],
        },
        {
            path: 'store-message',
            title: '/store',
            name: '门店',
            icon: 'el-icon-shopping-bag-2',
            catalogue: true,
            children: [
                {
                    path: 'store-message',
                    name: '查看门店列表',
                    isShow: true,
                },
                {
                    path: 'add-store-info',
                    name: '添加门店信息',
                    isShow: true,
                },

            ]


        },
        {
            path: 'scratch-code',
            title: '/scratch',
            name: '刮刮码',
            icon: 'el-icon-s-grid',
            catalogue: true,
            children: [
                {
                    path: 'scratch-code',
                    name: '查看刮刮码列表',
                    isShow: true,
                },
                {
                    path: 'add-scratch-code',
                    name: '添加刮刮码',
                    isShow: true,
                },
                {
                    path: 'check-scratch-code',
                    name: '核销刮刮码',
                    isShow: true,
                },
                {
                    path: 'scratch-check-log',
                    name: '查看核销记录列表',
                    isShow: true,
                },


            ]

        }
    ],
    commonStatusList: [
        {
            id: 0,
            name: "所有",
            tag: "",
        },
        {
            id: 1,
            name: "已发布",
            tag: "success",
        },
        {
            id: 2,
            name: "审核中",
            tag: "warning",
        },
        {
            id: 3,
            name: "已失效",
            tag: "danger",
        },
    ],
    statusSelectList: [
        {
            id: 1,
            name: "已发布",
            tag: "success",
        },
        {
            id: 2,
            name: "审核中",
            tag: "warning",
        },
        {
            id: 3,
            name: "已失效",
            tag: "danger",
        },
    ],
    // 权限管理
    admin: {
        name: '姓名',
        remark: '备注',
        email: '邮箱',
        refreshAuth: '刷新权限',
        updatePermissions: '用户权限同步成功',
        accountDetail: '管理员账号详情',
        searchUser: '搜索用户',
        userId: '用户ID',
        username: '用户名',
        password: '密码',
        role: '角色',
        onlySearch: '暂不支持修改用户ID,如需修改请先进行新增',
        rulesEmailTip: '请输入邮箱',
        rulesValid: '长度大于 3 个字符',
        rulesNameTip: '请输入名称',
        rulesPasswordTip: '请输入密码',
        rulesPasswordValid: '长度大于 6 个字符',
    },
    api: {
        name: '名称',
        identifier: 'API',
        apiDetail: '接口分类详情',
        method: '请求方式',
    },
    category: {
        name: '分类名称',
        identifier: '分类路径',
        detail: '接口分类详情'
    },
    role: {
        name: '角色名称',
        detail: '角色详情',
        onlyRead: '只读'
    },
    // 登录页
    login: {
        BackgroundManagementSystem: 'SMART SHOP ADMIN 后台管理系统',
        Account: '账号',
        Password: '密码',
        Login: '登录',
        RegisteredAccount: '注册账号',
        ForgetPassword: '忘记密码',
        CurrentVersion: '当前版本',
        EnterAccount: '请输入账号（或者邮箱）',
        EnterPassword: '请输入密码',
        LogErr: '登录出现错误：',
        EnterCorrectPwdInfo: '请输入正确的密码信息',
        EnterCorrectAccountInfo: "请输入正确的账号信息"


    },
    // 注册账号
    registerAccount: {
        BackgroundManagementSystem: 'SMART SHOP ADMIN 后台管理系统',
        RegisteredAccount: '注册账号',
        UserName: '用户名',
        Email: '邮箱',
        VerificationCode: '验证码',
        Password: '密码',
        EnterName: '请输入用户名',
        EnterEmail: '请输入邮箱',
        EnterVal: '请输入验证码',
        GetVerificationCode: '获取验证码',
        ReturnHomePage: '返回主页',
        Register: '注册',
        EnterPassword: '请输入密码',
        EnterCorrentEmail: '请先输入正确的邮箱',
        getVerCodeSuccess: '验证码获取成功',
        getVerCodeFail: '验证码获取出现错误：',
        userNameEmpty: '用户名不能为空',
        emailEmpty: '请先输入正确的邮箱',
        codeVerEmpty: '请先输入正确验证码',
        pwdEmpty: '密码不能为空',


    },
    // 忘记密码
    changePassword: {
        BackgroundManagementSystem: 'SMART SHOP ADMIN 后台管理系统',
        ResetPassword: '重置密码',
        Email: '邮箱',
        VerificationCode: '验证码',
        GetVerificationCode: '获取验证码',
        NewPassword: '新密码',
        EnterNewPassword: '请输入新密码',
        ReturnHomePage: '返回主页',
        EnterEmail: '请输入邮箱',
        EnterVal: '请输入验证码',
        EnterCorrentEmail: '请先输入正确的邮箱',
        getVerCodeSuccess: '验证码获取成功',
        getVerCodeFail: '验证码获取出现错误：',
        emailEmpty: '请先输入正确的邮箱',
        codeVerEmpty: '请先输入正确验证码',
        EnterNewPwd: '请输入新的密码',
        ResetSuccess: '密码重置成功',
        ResetPwdErr: '密码重置出现错误：'

    },
    status: '状态',
    statusMsg: '请选择',
    key: '关键字',
    keyMsg: '请输入关键字',
    filter: '过滤',
    add: '添加',
    edit: '编辑',
    delete: '移除',
    save: '保存',
    back: '返回',
    operate: '操作',
    weight: '权重',
    classify: '分类',
    resourceSelect: '资源选择',
    pcIcon: 'PC端图标',
    wapIcon: 'WAP端图标',
    errorMsg: '获取数据失败',
    cancelDelete: '取消删除',
    confirm: {
        title: '此操作将永久删除该数据, 是否继续?',
        tip: '提示',
        determine: '确定',
        cancel: '取消'
    },
    successfullyDeleted: '删除成功',
    successfullyAdded: '添加成功',
    successfullyModified: '修改成功',
    checkForm: '请检查表单!',
    all: '所有',
    copy: {
        copy: '复制',
        paste: '粘贴',
        copySuccessful: '复制成功',
        copyFailed: '复制失败',
        inconformityContent: '粘贴板的内容不符合当前列表信息',
    },
    // 公共部分
    commonInfo: {
        classify: '分类',
        add: '添加',
        filter: '过滤',
        Store: '门店',
        UpdateInfo: '修改资料',
        ChangePassword: '修改密码',
        AboutSystem: '关于系统',
        LogOut: '退出登录',
        ClearCache: '清除缓存',
        StoreList: '查看门店列表',
        AddStore: '添加门店信息',
        Back: '返回',
        DeleteItemWarning: '此操作将永久删除该数据，是否继续?',
        Confirm: '确定',
        Cancel: '取消',
        ImportSucceeded: '导入成功',
        UpdateSucceed: '更新评分成功',
        DeleteSucceed: '删除成功',
        CancelDelete: '取消删除',
        AddStoreSucceed: '添加门店成功',
        Tips: '提示',
        ChangeLanguage: '确定切换语言吗?',
        ModifyData: '修改资料',
        nickName: '昵称',
        headPortrait: '头像',
        Loading: '加载中...',
        // 警告部分
        EnterInformation: '请输入信息',
        logOutConfirm: "退出登录系统，是否继续？",
        OldPassword: '旧密码',
        NewPassword: '新密码',
        Save: '保存',
        OldPasswordEmptyWarning: '旧密码不能为空',
        NewPasswordEmptyWarning: '新密码不能为空',
        OldNewSameWarning: '请不要设置与旧密码相同的新密码',
        PasswordModifySuccess: '密码修改成功',
        About: '关于',
        BackgroundManagementSystem: 'SMART SHOP ADMIN 后台管理系统',
        AboutSystem: '关于系统',
        Version: '版本：',
        // 刮刮码
        ScratchCode: '刮刮码',
        CodeList: '查看刮刮码列表',
        addScratchCode: '添加刮刮码',
        scratchCheckLog: '查看核销记录列表',
        checkScratchCode: '核销刮刮码',
        viewDetail: '详情',
        addSucceed: '添加成功',
        status: '状态',
        pleaseSelect: '请选择',
        keyWord: '关键字',
        pleaseEnterKey: '请输入关键字',
        beginTime: '开始时间:',
        pleaseSelectBeginTime: '请选择开始时间',
        endTime: '结束时间:',
        pleaseSelectEndTime: '请选择结束时间',
        success: '成功',
        accountNoPermission: '账号无权限'
    },
    // 查看门店
    storeMessage: {
        Country: '国家',
        Province: '省份',
        City: '城市',
        CompanyName: '门店名称',
        TypeOfRetailArea: '零售区类型',
        newest: '最新',
        Oldest: '最旧',
        area: "门店面积",
        SellOutMoney: '营业额',
        SMOKSellOutMoney: 'smok营业额',
        StoreLevel: '门店等级',
        // 下拉框部分
        SelectCountry: '请选择国家',
        SelectProvince: '请选择省份',
        SelectCity: '请选择城市',
        SelectCompanyName: '请输入门店名称',
        SelectRetailArea: '请选择零售区',
        SelectCompanyArea: '请选择门店面积',
        SelectMonthlySellOut: '请选择营业额',
        SelectMonthlySmokSellOut: '请选择smok营业额',
        SelectCompanyLevel: '请选择门店等级',
        Search: '查询',
        DownloadTheFile: '导出excel',
        UpdateScore: '更新评分',
        Score: '评分',
        Operation: '操作',
        Edit: '编辑',
        Delete: '删除',
        UploadFiles: '上传文件'
    },
    // 添加门店
    addStore: {
        AddStore: '添加门店',
        Country: '国家',
        Province: '省份',
        City: '城市',
        TypeOfRetailArea: '零售区类型',
        CompanyName: '门店名称',
        area: "门店面积",
        SellOutMoney: '营业额',
        SMOKSellOutMoney: 'smok营业额',
        ContactInformation: "联系方式",
        StoreAddress: '门店地址',
        StoreZipCode: '门店邮编',
        AddNow: '立即添加',
        Added: '已添加',
        // 警告部分
        EnterInformation: '请输入信息'


    },
    // 联系方式
    contactMethods: {
        Position: "职位",
        Name: '名字',
        Tel: '电话',
        Email: '邮箱',
        Delete: '删除',
        Add: '新增',
        Cancel: "取消",
        Confirm: '确定',
        Edit: '编辑'
    },
    // 编辑门店
    editStoreDetail: {
        EditDetails: '编辑门店详情',
        Country: '国家',
        Province: '省份',
        City: '城市',
        TypeOfRetailArea: '零售区类型',
        CompanyName: '门店名称',
        area: "门店面积",
        SellOutMoney: '营业额',
        SMOKSellOutMoney: 'smok营业额',
        EditContactInformation: "编辑联系方式",
        StoreAddress: '门店地址',
        StoreZipCode: '门店邮编',
        Number: '编码',
        OutletStatus: '营业状态',
        Picture: '图片',
        ImageLink: '图片链接',
        Score: '得分',
        DateDate: '数据日期',
        Save: '保存',
        EditSuccess: '编辑门店成功'
    },
    // 刮刮码
    scratchCode: {
        addScratchCode: '添加刮刮码',
        count: '数量',
        editScratchCodeDetail: '刮刮码详情',
        editScratchCheckCodeDetail: '核销码记录详情',
        checkScratch: '核销',
        addScratchSucceed: '添加刮刮码成功',
        uploadCheck: '上传文件核销',
        checkTime: '核对次数',
        scratchCode: '刮刮码',
        pleaseEnterScratchCode: '请输入刮刮码',
        scratchCodeExample: '（ 如果输入多个，需要用空格分隔，如12345678 23456789 ）',
        manualCheck: '人工核销',
        succeedTime: '成功次数',
        failedTime: '错误次数',
        repeatTime: '重复次数',
        currentSucceedTime: '本次核销成功',
        failedNumber: '错误号码',
        repeatedCheck: '重复核销',
        individual: '个',
    }

}
export default lang;